import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Modal, Select, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import countryList from 'react-select-country-list';
import { cw, hp } from '../../utils';

import AuthHeader from './Header';
import axios from 'axios';

class SignIn extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            visaMomoModalVisible: false, countrying: false, countryModal: false,
            currency: '', modalFooterImages: [],
        };
    }

    _signin = e => {
        e.preventDefault();
        const { form: { validateFields }, signIn, intl, _utils: { lang } } = this.props;
        validateFields((err, vals) => {
            if (!err) {
                signIn(intl, lang, { email: vals.email.toLowerCase().trim(), password: vals.password }, (res) => {
                    if (!res.user.country || res.user.country === 'undefined') {
                        this.setState({ countryModal: true });
                    } else {
                        window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                    }
                });
            }
        });
    };

    _setCountry = e => {
        e.preventDefault();
        const { form: { validateFields }, } = this.props;
        validateFields(['country'], (err, v) => {
            if (!err) {
                var user = JSON.parse(hp.getCookie('user') || '{}');
                var account = JSON.parse(hp.getCookie('active_account') || '{}');
                this.setState({ countrying: true });
                axios({
                    method: 'put',
                    url: `${hp.getApiBaseUrl()}/accounts/${account.id}`,
                    headers: { 'x-access-token': hp.getCookie('user_token') },
                    data: v
                }).then((response) => {
                    const res = response.data;
                    if (res.statusCode === 200) {
                        axios({
                            method: 'put',
                            url: `${hp.getApiBaseUrl()}/users/${user.user_id}`,
                            headers: { 'x-access-token': hp.getCookie('user_token') },
                            data: v
                        }).then((response) => {
                            const res = response.data;
                            if (res.statusCode === 200) {
                                window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                            } else {
                                this.setState({ countrying: false });
                                notification.error({ message: this.props.intl.formatMessage(cw['SetCountry.Failed']) });
                            }
                        }).catch(() => {
                            this.setState({ countrying: false });
                        });
                    } else {
                        this.setState({ countrying: false });
                        notification.error({ message: this.props.intl.formatMessage(cw['SetCountry.Failed']) });
                    }
                }).catch(() => {
                    this.setState({ countrying: false });
                    notification.error({ message: this.props.intl.formatMessage(cw['SetCountry.Failed']) });
                });
            }
        });
    }

    render() {
        const { form: { getFieldDecorator, getFieldValue }, _utils, _auth: { signingIn } } = this.props;

        return (
            <React.Fragment>
                <Form id="esoko__signin" autoComplete="off" hideRequiredMark onSubmit={this._signin}>
                    <AuthHeader screen="signin" />

                    <Form.Item required={true} colon={false} label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}>
                        {getFieldDecorator('email', {
                            rules: [
                                { required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> }
                            ]
                        })(
                            <Input autoFocus autoComplete="off" size="large" placeholder="you@domain.com" sso-id="login-username" />
                        )}
                    </Form.Item>
                    <Form.Item required={true} colon={false} label={<FormattedMessage id="Label.Password" defaultMessage="Password" />}>
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> }
                            ]
                        })(
                            <Input.Password autoComplete="off" size="large" type="password" placeholder={this.props.intl.formatMessage(cw['Placeholder.Password'])} sso-id="login-password" />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button className="submitBtn" block size="large" type="primary" htmlType="submit" disabled={!getFieldValue('email') && !getFieldValue('password')} loading={signingIn} sso-id="login-button">
                            <FormattedMessage id="auth_signin_button" defaultMessage="Sign in" />
                        </Button>
                    </Form.Item>

                    <div className="formLinks">
                        <Link to={`/${_utils.lang || 'en'}/reset${window.location.search}`} className="auth_form_links_forgot" sso-id="reset-link">
                            <FormattedMessage id="auth_signin_forgot_link" defaultMessage="Forgot password?" />
                        </Link>
                        <p>
                            <span className="noAccountText"><FormattedMessage id="auth_signin_not_account" defaultMessage="Don't have an account?" /></span>
                            <Link to={`/${_utils.lang || 'en'}/signup${window.location.search}`} sso-id="signup-link"><FormattedMessage id="auth_signin_create_account_link" defaultMessage="Sign up" /></Link>
                        </p>
                    </div>
                </Form>

                <Modal title={null} visible={this.state.countryModal} centered footer={null}>
                    <h4><FormattedMessage id="SetCountry.Title" defaultMessage="Choose a country" /></h4>
                    <p><FormattedMessage id="SetCountry.Description" defaultMessage="We realised you did not choose a country upon signup, please choose one now." /></p>

                    <Form id="esoko__signin" hideRequiredMark={true} onSubmit={this._setCountry}>
                        <Form.Item colon={false} label={<FormattedMessage id="Label.Country" defaultMessage="Country" />}>
                            {getFieldDecorator('country', {
                                rules: [
                                    { required: true, message: <span /> },
                                ],
                                initialValue: 'Ghana',
                            })(
                                <Select size="large" showSearch={true} sso-id="signup-userCountry">
                                    {(countryList().getData()).map(cnt => (
                                        <Select.Option key={cnt.label} value={cnt.label}>{cnt.label}</Select.Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>

                        <Button className="submitBtn" size="large" type="primary" htmlType="submit" loading={this.state.countrying} sso-id="signup-button">
                            <FormattedMessage id="Button.Submit" defaultMessage="Submit" />
                        </Button>
                    </Form>
                </Modal>
            </React.Fragment>
        );
    }
}

const SignInForm = Form.create()(SignIn);
export default SignInForm;